import React from "react";

import { connect } from "react-redux";
import { Input } from "../../Input";
import { Button } from "../../Button";
import language from "../../../language";
import validateEmail from "../../../utils/validateEmail";
import axios from "axios";
import toastMessage from "../../../utils/toastMessage";
import icons from "../../../constants/icons";
import { getStorage } from "../../../utils/storage";
import { Loading } from "../../Loader";
import api from "../../../utils/api";

class SendOTP extends React.Component {
  state = {
    email: "",
    isSubmitting: false,
    error: {},
    user: {},
    isLoading: false,
    userId: "",
  };

  componentDidMount = async () => {
    const user = await getStorage();

    await this.setState({ user, email: user.preferred_username });
  };

  onChangeText = (field, e) => {
    let { error } = this.state;

    delete error[field];

    this.setState({ [field]: e.target.value });
  };

  validateForm = () => {
    let { error, email } = this.state;
    if (email === "") {
      error.email = language[this.props.defaultLanguage].email_required;
    } else if (!validateEmail(email)) {
      error.email = language[this.props.defaultLanguage].invalid_email_required;
    }

    this.setState({ error });
  };

  onSubmit = async (e) => {
    e?.preventDefault();
    await this.validateForm();

    if (Object.keys(this.state.error).length === 0) {
      this.setState({ isSubmitting: true });

      const { user, email } = this.state;

      const options = {
        method: "POST",
        url: `${api("account")}/otp`,
        data: {
          email,
        },
        headers: {
          Authorization: `Bearer ${user.accessToken}`,
        },
      };

      axios(options)
        .then((data) => {
          this.setState({ isSubmitting: false });

          this.onSuccess(data.data);
        })
        .catch((error) => {
          this.setState({ isSubmitting: false });

          toastMessage(
            "error",
            language[this.props.defaultLanguage].email_not_exist
          );
        });
    }
  };

  onSuccess = async () => {
    const { email, userId } = this.state;

    this.props.handleOnOTPSubmitted({
      email,
      userId,
      otpSent: true,
    });
  };

  render() {
    return (
      <>
        {this.state.isLoading ? (
          <Loading fullScreen />
        ) : (
          <div className="auth-form">
            <form>
              <Input
                label={language[this.props.defaultLanguage].email_address}
                placeholder={
                  language[this.props.defaultLanguage].email_placeholder
                }
                required
                leftIcon={icons.email}
                value={this.state.email}
                error={this.state.error.email}
                onChange={(e) => this.onChangeText("email", e)}
                disabled
              />
              <Button
                text={language[this.props.defaultLanguage].verify}
                className="w-100 mb-2"
                isSubmitting={this.state.isSubmitting}
                onPress={this.onSubmit.bind(this)}
              />
            </form>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(SendOTP);
